import { render, staticRenderFns } from "./CalendarTab.vue?vue&type=template&id=31088928&scoped=true"
import script from "./CalendarTab.vue?vue&type=script&lang=js"
export * from "./CalendarTab.vue?vue&type=script&lang=js"
import style0 from "./CalendarTab.vue?vue&type=style&index=0&id=31088928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31088928",
  null
  
)

export default component.exports